import _ from 'lodash';

import { accounts as accountsAPI } from '@/services';

export default {
  data: () => ({
    timeoutThreshold: 1000,
    timeout: {
      promoters: null,
      responsible: null,
      typist: null,
      assignee: null,
    },
    searching: {},
    searchingKeyName: '',
  }),
  methods: {
    // handlers :: search
    handlePromotersSearch(value, searchingKeyName) {
      if (searchingKeyName) {
        this.$set(this.searching, searchingKeyName, false);
        this.searchingKeyName = searchingKeyName;
      }
      this.callSearch({
        options: { search: value },
        target: 'promoters',
        method: 'searchPromoters',
      });
    },
    handleResponsibleSearch(value, params, searchingKeyName) {
      if (searchingKeyName) {
        this.$set(this.searching, searchingKeyName, false);
        this.searchingKeyName = searchingKeyName;
      }
      this.callSearch({
        options: { search: value, ...params },
        target: 'responsible',
        method: 'searchResponsible',
        id_key: 'user_id',
      });
    },
    handleTypistsSearch(value, params, searchingKeyName) {
      if (searchingKeyName) {
        this.$set(this.searching, searchingKeyName, false);
        this.searchingKeyName = searchingKeyName;
      }
      this.callSearch({
        options: { search: value, ...params },
        target: 'typists',
        method: 'searchTypists',
      });
    },

    appendSearchResults({
      data, target, options, id_key,
    }) {
      const list = this.list[target];
      for (const item of data.data.data) {
        list.push({
          ...item,
          name: item.name,
          value: item[id_key],
          search: options.search,
        });
      }
      this.list[target] = _.uniqBy(_.reverse(list), 'value');
    },

    finishSearch() {
      if (this.searchingKeyName) this.searching[this.searchingKeyName] = false;
    },

    async runSearch({
      options, target, method, id_key,
    }) {
      try {
        const { data } = await accountsAPI[method](options);
        if (!options.search) this.timeout[target] = null;
        this.appendSearchResults({
          data, target, options, id_key,
        });
      } catch (err) {
        if (this.handlerError) this.handlerError(err);
      } finally {
        this.finishSearch();
      }
    },

    // search
    callSearch({
      options, target, method, id_key = 'id',
    }) {
      if (this.searchingKeyName) this.searching[this.searchingKeyName] = true;

      clearTimeout(this.timeout[target]);
      this.timeout[target] = setTimeout(() => {
        this.runSearch({
          options, target, method, id_key,
        }).catch(() => {});
      }, this.timeoutThreshold);
    },
  },
};
